export const dev_key = "Test-g#A+&xk*Yn4qjTVP29C7cUBSs=5yLQpJ";
export const prod_key = "Prod-s7yTIrEthG3!Rd^4KV9&ZukU2J6Wmo*a";



// WEBPACK FOOTER //
// ./src/apiKeys.js